export default __webpack_public_path__ + "static/media/instagram.b5e8d6c5.svg";